import { Button } from "@volca/ui/components/ui/button";
import { Stack } from "@volca/ui/components/ui/stack";
import { cn } from "@volca/ui/lib/utils";
import { ManagerStartThreadForm } from "@/payroll/pack-chat/manager-start-thread-form";
import { PackChatState } from "@/payroll/pack-chat/pack-chat-state";
import type { IPackChatThreadDetail } from "@/payroll/pack-chat/types";
import type { ThreadFilter } from "./pack-chat-thread-filter";

export const PackChatIdlePane = ({
  businessId,
  periodStart,
  runId,
  starting,
  nothingMatches,
  search,
  filter,
  onShowAll,
  onCancelStart,
  onStarted,
}: {
  businessId: string | null;
  periodStart: string;
  runId: string | null;
  starting: boolean;
  nothingMatches: boolean;
  search: string;
  filter: ThreadFilter;
  onShowAll: () => void;
  onCancelStart: () => void;
  onStarted: (thread: IPackChatThreadDetail) => void;
}) => (
  <div className="h-full min-h-0 min-w-0 overflow-y-auto">
    {/* The start form lays out its own two panes to the pane edge and owns
        its padding; the states either side of it stay a readable column. */}
    <Stack
      gap={0}
      align="stretch"
      className={cn({
        "min-w-0": starting,
        "h-full max-w-184 px-5 py-5": !starting,
      })}
    >
      {nothingMatches ? (
        <PackChatState
          title={
            search.trim() ? "No threads match that search" : `Nothing ${filter}`
          }
          body={
            search.trim()
              ? `No thread in this period mentions "${search.trim()}".`
              : "Every question in this period is under one of the other filters."
          }
          action={
            <Button
              size="sm"
              variant="secondary"
              className="mt-3"
              onClick={onShowAll}
            >
              Show all threads
            </Button>
          }
        />
      ) : starting ? (
        <ManagerStartThreadForm
          businessId={businessId}
          periodStart={periodStart}
          activeRunId={runId}
          onCancel={onCancelStart}
          onStarted={onStarted}
        />
      ) : (
        <PackChatState
          title="Nothing selected"
          body="Pick a technician on the left to read their questions."
        />
      )}
    </Stack>
  </div>
);
